import RentFiguresChart from './RentFiguresChart'

export default RentFiguresChart
